export const removeImageTag = (
  htmlString: string | undefined
): string | undefined => htmlString?.replace(/<img[^>]*>/g, "");
